import React from 'react';
import fr from 'facet-rest';
import useMobileLayout from 'Hooks/useMobileLayout';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { FDStack, FDTitleText } from '@facet-wealth/design';
import { ImageRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/ImageRel';
import {
  SecondaryActionButtonRel,
} from 'Packages/FacetCore/Experimental/RelationshipComponents/SecondaryActionButtonRel';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverrideLite';
import { Text } from 'Packages/FacetDesign/Components/Text';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => Text,
    _customProps: { Component: FDTitleText, size: 'sm', color: 'textSecondary' },
  }, overrideReadOnly);

export const Articles = ({ collection }) => {
  const isMobile = useMobileLayout();

  if (collection.resources().length() === 0) {
    return null;
  }

  return (
    <FDStack direction={isMobile ? 'column' : 'row'} spacing={3}>
      {
        collection.resources().list().map(res => (
          <FDStack direction="column" spacing={1} flex={1}>
            <ImageRel objectFit="cover" relationship={res.relationship(fr.relationships.image.name)} rounded />
            <MetaControl resource={res} attrName={'title'} metaOverrideSet={metaOverrideSet} />
            <SecondaryActionButtonRel size="sm" relationship={res.relationship(fr.relationships.navigate.name)} alignSelf="flex-start" />
          </FDStack>
        ))
      }
    </FDStack>
  );
};
